"use client";
import { useEffect } from "react";
import { Button } from "@shared/src/components/ui/button";
import { useAuthStore } from "@shared/src/stores/useAuthStore";

// Error boundaries must be Client Components

export default function GlobalError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  useEffect(() => {
    // Log the error to your error reporting service
    console.error("Global Error:", error);
  }, [error]);


  return (
    // global-error must include html and body tags
    <html>
      <body>
        <div className="flex min-h-screen flex-col items-center justify-center gap-4 p-8">
          <h1 className="text-2xl font-bold">Something went wrong!</h1>
          <p className="text-text-secondary">{error.message}</p>
          <Button
            onClick={reset}
            variant="primary"
            size="lg"
            radius="full"
            width="default"
            className="px-6 py-4 h-auto"
          >
            Try again
          </Button>
        </div>
      </body>
    </html>
  );
}
